const offers=[
    {
        id:1,
        name:"Bank Offer",
        desc:"Upto ₹1,000.00 discount on select Credit Cards, ICICI Bank Debit Cards…",
        offer:"12 Offers >"
    },
    {
        id:2,
        name:"Partner Offers",
        desc:"Win IPL Merchandise on purchase of JBL products",
        offer:"3 Offers >"
    },
    {
        id:3,
        name:"No Cost EMI",
        desc:"No Cost EMI on select cards for orders above ₹ 3000 ",
        offer:"1 Offers >"
    },
    {
        id:4,
        name:"Amaze Rewards",
        desc:"Buy This  Products and unlock the coupon worth ₹ 300",
        offer:"3 Offers >"
    },
]

const statistics=[
    {
        id:1,
        img:"https://m.media-amazon.com/images/G/31/A2I-Convert/mobile/IconFarm/trust_icon_free_shipping_81px._CB630870460_.png",
        stat:"Free Delivery"
    },
    {
        id:2,
        img:"https://m.media-amazon.com/images/G/31/A2I-Convert/mobile/IconFarm/icon-cod._CB485937110_.png",
        stat:"Pay On Delivery"
    },
    {
        id:3,
        img:"https://m.media-amazon.com/images/G/31/A2I-Convert/mobile/IconFarm/icon-returns._CB484059092_.png",
        stat:"7 Days Replacement"
    },
    {
        id:4,
        img:"https://m.media-amazon.com/images/G/31/A2I-Convert/mobile/IconFarm/icon-amazon-delivered._CB485933725_.png",
        stat:"Amaze Deliver"
    },
    {
        id:5,
        img:"https://m.media-amazon.com/images/G/31/A2I-Convert/mobile/IconFarm/icon-top-brand._CB617044271_.png",
        stat:"Top Brands"
    },
    {
        id:6,
        img:"https://m.media-amazon.com/images/G/31/A2I-Convert/mobile/IconFarm/Secure-payment._CB650126890_.png",
        stat:"Secured Transaction"
    },
]

export {offers,statistics}